import Table from "react-bootstrap/Table";

function DetailsTable() {
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>S.No.</th>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>
            Information
          </th>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>
            Details
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Principal</td>
          <td>Ms. Pinki Kaushik</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Total No. of Teachers</td>
          <td>27</td>
        </tr>
        <tr>
          <td>2a.&#10217;</td>
          <td>PGT</td>
          <td>13</td>
        </tr>
        <tr>
          <td>2b.&#10217;</td>
          <td>TGT</td>
          <td>05</td>
        </tr>
        <tr>
          <td>2c.&#10217;</td>
          <td>PRT</td>
          <td>07</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Teachers Section Ratio</td>
          <td>1.5:1</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Detail of Special Educator</td>
          <td>Gaurav Solanky ( B.ED)</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Detail of Counsellor and Wellness Teacher</td>
          <td>Mrs. Sarita</td>
        </tr>
      </tbody>
    </Table>
  );
}

export default DetailsTable;
